export default __webpack_public_path__ + "static/media/portfolio-114.76124e79.jpg";